import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as analyseActions from '../../actions/analytics';
import C_A from '../../constants/analytics';


const LogPageView = (WrappedComponent) => {
    class Logger extends React.Component {
        componentWillMount() {
            let page;
            if (this.props.location.pathname.indexOf(this.props.match.params.id) > -1) {
                page = this.props.location.pathname.slice(0, this.props.location.pathname.indexOf(this.props.match.params.id));
            }
            else {
                page = this.props.location.pathname;
            }
            this.props.actions.reportAnalytics([C_A.PAGE_VIEW, page]);
        }

        render() {
            return <WrappedComponent {...this.props} />
        }
    }

    Logger.propTypes = {
        match: PropTypes.object,
        location: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired
    };

    function mapDispatchToProps(dispatch) {
        return {
            actions: bindActionCreators(analyseActions, dispatch)
        }
    }

    return connect(null, mapDispatchToProps)(Logger);
}

export default LogPageView;




// WEBPACK FOOTER //
// ./containers/AnalyticsWrapper/index.js